import { useState } from "react";
import { Link, useLocation } from "react-router-dom";
import { playStoreUrl, trackEvent } from "./analytics";

const NAV_LINKS = [
  { href: "/", label: "Home" },
  { href: "/how-it-works", label: "How it Works" },
  { href: "/join-us", label: "Join Us" },
  { href: "/safety", label: "Safety" },
  { href: "/blog", label: "Blog" },
  { href: "/download", label: "Download" },
];

function Navbar() {
  const { pathname } = useLocation();
  const [open, setOpen] = useState(false);

  return (
    <>
      <div className="topbar-spacer" />
      <header className="topbar shell">
        <div className="bar-inner">
          <Link className="brand" to="/">
            <span className="tile">
              <img src="/logo.webp" alt="Baatcheet" width="512" height="512" />
            </span>
            <span className="wm">
              <span className="en">Baat</span>
              <span className="hi">चीत</span>
            </span>
          </Link>

          <nav>
            {NAV_LINKS.map((link) => (
              <Link
                key={link.href}
                to={link.href}
                className={pathname === link.href ? "on" : ""}
              >
                {link.label}
              </Link>
            ))}
          </nav>

          <div className="right">
            <a
              className="btn btn-ghost"
              href={playStoreUrl('navbar')}
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => trackEvent('play_store_click', { location: 'navbar' })}
            >
              Get App
            </a>
            <Link className="btn btn-pri" to="/partner-landing">
              Join Now →
            </Link>
          </div>

          <button
            className="mob-menu-btn"
            onClick={() => setOpen((o) => !o)}
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
          >
            <span className={`hb${open ? " hb-open" : ""}`}>
              <i />
              <i />
              <i />
            </span>
          </button>
        </div>
      </header>

      {open && (
        <div className="mob-overlay" onClick={() => setOpen(false)}>
          <nav className="mob-drawer" onClick={(e) => e.stopPropagation()}>
            <div className="mob-drawer-head">
              <Link className="brand" to="/" onClick={() => setOpen(false)}>
                <span className="tile">
                  <img src="/logo.webp" alt="Baatcheet" width="512" height="512" />
                </span>
                <span className="wm">
                  <span className="en">Baat</span>
                  <span className="hi">चीत</span>
                </span>
              </Link>
              <button
                className="mob-close"
                onClick={() => setOpen(false)}
                aria-label="Close menu"
              >
                ✕
              </button>
            </div>

            <div className="mob-links">
              {NAV_LINKS.map((link) => (
                <Link
                  key={link.href}
                  to={link.href}
                  className={`mob-link${pathname === link.href ? " on" : ""}`}
                  onClick={() => setOpen(false)}
                >
                  {link.label}
                </Link>
              ))}
            </div>

            <div className="mob-drawer-foot">
              <a
                className="btn btn-ghost"
                href={playStoreUrl('navbar_mobile')}
                target="_blank"
                rel="noopener noreferrer"
                style={{
                  textAlign: "center",
                  justifyContent: "center",
                  display: "flex",
                }}
                onClick={() => { trackEvent('play_store_click', { location: 'navbar_mobile' }); setOpen(false); }}
              >
                Get App
              </a>
              <Link
                className="btn btn-pri"
                to="/partner-landing"
                style={{
                  textAlign: "center",
                  justifyContent: "center",
                  display: "flex",
                }}
                onClick={() => setOpen(false)}
              >
                Join Now
              </Link>
            </div>
          </nav>
        </div>
      )}
    </>
  );
}

export default Navbar;
